import { RegistrationGuestLogin } from 'legacy/hpscoutso/components/widgets/public/guestLogin/RegistrationGuestLogin'
import { OnbPageURLs } from 'legacy/lut/classes/models/onboarding/Onboarding'
import { useLocation } from 'react-router-dom'

import { getUrlParam } from 'core-components/helpers/url'
import { LayoutLogin } from 'core/layout/Login'
import { RegistrationHpidSignIn } from 'onboarding/components/registration/hpidSignIn/RegistrationHpidSignIn'
import { HPLogo } from 'onboarding/components/ui/logo/HPLogo'

import styles from './RegistrationLoginPage.module.scss'

const PAGES_SIGNING_IN_WITH_HPID: string[] = [
  OnbPageURLs.BPRegistration,
  OnbPageURLs.TermsAndConditions,
]

export const RegistrationLoginPage = () => {
  const location = useLocation()
  const signsInWithHpid = PAGES_SIGNING_IN_WITH_HPID.includes(
    getUrlParam('page', location.pathname) || ''
  )

  return (
    <LayoutLogin
      content={({ onSubmit, progress }) => {
        if (signsInWithHpid) {
          return (
            <div className={styles.root}>
              <div className={styles.cardHpid}>
                {/* The card reserved space for a logo through --lgpg-card-logo__* CSS
                    variables that are declared nowhere, so it never showed one. */}
                <RegistrationHpidSignIn
                  onSignIn={onSubmit}
                  progress={progress}
                  programName={'Business Partner Registration'}
                  logo={<HPLogo className={styles.logo} />}
                />
              </div>
            </div>
          )
        }

        return (
          <div className={styles.root}>
            <div className={styles.card}>
              <RegistrationGuestLogin />
            </div>
          </div>
        )
      }}
    />
  )
}
